import isNumber from 'utilities/isNumber';

import { getAgentNpn } from './getSessionData';

const postJSON = async ({ body, url, ApiKey }) => {
    const agentNpn = getAgentNpn();
    const options = {
        body: JSON.stringify(body),
        headers: {
            'Content-Type': 'application/json',
            ...(isNumber(agentNpn) && { isPurl: true }),
            ...(agentNpn && { AgentNPN: agentNpn }),
            ...(ApiKey && { Authorization: `ApiKey: ${ApiKey}` })
        },
        method: 'POST'
    };

    try {
        const response = await fetch(url, options);
        if (/text\/plain/.test(response.headers.get('Content-Type'))) {
            return await response.text();
        }

        return await response.json();
    } catch (error) {
        console.error(error);

        return {};
    }
};

export default postJSON;
